
import Metric from '@/models/Metric'
// import Plant from '@/models/Plant'
import Vue, { PropType } from 'vue'

import DashboardStatCard from '@/ui/controls/dashboard/DashboardStatCard.vue'

export default Vue.extend({
  components: {
    DashboardStatCard,
  },
  props: {
    metric: {
      type: Object as PropType<Metric<unknown>>,
      required: true,
    },
    item: Object,
  },
  computed: {
    label(): string {
      return this.metric.getLabel(this.item)
    },
    value(): number {
      return this.metric.getValue(this.item)
    },
    formattedValue(): string {
      return this.metric.getFormattedValue(this.item)
    },
    icon(): string {
      return this.metric.getIcon(this.item)
    },
    color(): string {
      return this.metric.getColor(this.item) || 'primary'
    },
  },
})
